import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import { Link } from "react-router-dom";

function TowerRushJackpotPromoFun(props: any) {
    const { theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <InformationWrapper>
                <Container>
                    <ImageWrapper className="GTRCard">
                        <Link to="/instant-games/galaxsys/tower-rush">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRInnerCard}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                    </ImageWrapper>
                    <PrizeWrapper>
                        <Prize>
                            <h3>₹10 Lakh</h3>
                            <p>Total promotion prize pool</p>
                        </Prize>
                        <Seperater />
                        <Prize>
                            <h3>₹1 Lakh</h3>
                            <p>Daily jackpot prize</p>
                        </Prize>
                        <Seperater />
                        <Prize>
                            <h3>1 Winner</h3>
                            <p>Selected every day</p>
                        </Prize>
                    </PrizeWrapper>
                    <h1>This Diwali, Win a Share of the ₹10 Lakh Jackpot!</h1>
                </Container>

                <Container>
                    <h2>How to Claim</h2>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRSteps}`}
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Container>

                <Container>
                    <h2>Terms & Conditions</h2>
                    <TermsList>
                        <li>The promotion runs from <strong>6th November to 16th November.</strong></li>
                        <li>Each qualifying bet of <strong>₹1,000</strong> on Tower Rush earns one entry into the daily jackpot draw.</li>
                        <li>Multiple qualifying bets can earn multiple entries during the promotion period.</li>
                        <li><strong>One winner</strong> will be selected each day and awarded <strong>₹1 Lakh.</strong></li>
                        <li>The total jackpot prize pool for the promotion is <strong>₹10 Lakh.</strong></li>
                        <li>Only valid bets placed on Tower Rush during the promotion period will qualify.</li>
                        <li>The promotion is subject to the applicable terms and conditions.</li>
                    </TermsList>
                </Container>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(TowerRushJackpotPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;

    h1, h2, p {
        margin: 0;
        padding: 0;
    }

    h1, h2 {
        width: 100%;
        color: #211E32;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        font-family: 'Inter-Bold';
        line-height: normal;
    }

    h1 {
        font-size: 20px;
        text-transform: none;
    }

    h2 {
        font-size: 18px;
        text-transform: capitalize;
    }

    .top-para {
        width: 100%;
        color: #444;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px;
        text-transform: none;
    }

    .GTRCard {
        & span {
            display: flex !important;
            justify-content: center !important;

            img {
                width: 50%;
            } 
        }
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    background-color: #fff;
    padding: 2.5rem 1.5rem;
    border-radius: 8px;
`;

const Table = styled.table`
    width: 80%;
    border-collapse: separate;
    border-spacing: 0 10px;
    table-layout: fixed;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    line-height: 35px;
    text-transform: capitalize;
    margin: 0 auto;

    td {
        padding: 1rem;
    }

    thead tr th {
        color: #444;
        font-weight: 400;
    }

    tbody tr {
        background: #734F09;
    }

    tbody tr td {
        font-weight: 600;
    }

    tbody tr td:first-child {
        border-radius: 5px 0 0 5px;
    }
    tbody tr td:last-child {
        border-radius: 0 5px 5px 0;
    }
`;

const ImageWrapper = styled.div`
    width: 85%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(7px);
    
    img {
        width: 100%;
    }
`;

const TermsList = styled.ul`
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
        color: #444;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        background: #EBEBEB;
        padding: 12px 1.5rem 12px 2.5rem;
        position: relative;
    }

    li::before {
        content: "✦";
        position: absolute;
        color: #444;
        left: 1.5rem;
        top: 12px;
    }
`;

const PrizeWrapper = styled.div`
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px 100px;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #000000;
    gap: 50px;
    margin-bottom: 10px;
`;

const Prize = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    padding: 5px;

    h3, p {
        margin: 0;
        padding: 0;
        text-align: left;
        text-transform: none;
        color: #444;
        font-style: normal;
        text-transform: capitalize;
    }

    h3 {
        font-size: 25px;
        font-weight: 700;
        line-height: 18.801px;
    }

    p {
        font-size: 15.313px;
        font-weight: 400;
        line-height: 24px;
    }
`;

const Seperater = styled.div`
    width: 1px;
    flex: 0 0 1px;
    background: #000000;
    align-self: stretch;
`;